import React from 'react'
import { TextInput } from '@tecuity/granite-ui/TextInput'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'

const MiscRecordDetailHistoryFieldDrawerContent = ({ field, onLabelChange, onIsEnabledChange }) => {
  return (
    <div className="misc-record-detail-history-field-drawer-content">
      <TextInput
        label="Label"
        value={field.Label}
        onChange={(e) => onLabelChange(e.target.value)}
      />
      <Checkbox
        label="Is Enabled"
        checked={!!field.IsEnabled}
        onChange={(val) => onIsEnabledChange(val)}
      />
    </div>
  )
}

export default MiscRecordDetailHistoryFieldDrawerContent
